<div class="alert mb-20 alert-{{type}}" *ngIf="show">
    <div [innerHtml]="message"></div>
    <span class="close clickable" (click)="show = false">
        <app-icon icon="close-grey" size="xxs"></app-icon>
    </span>
</div>
